import Clickable from 'components/Common/Clickable'
import LineBoltIcon from 'LuxKit/Icons/line/LineBoltIcon'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalContext from 'contexts/ModalContext'
import { rem } from 'polished'
import { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import ExperienceInstantConfirmationModal from './ExperienceInstantConfirmationModal'

const IconText = styled(Clickable)`
  display: inline-flex;
  align-items: center;
  gap: ${rem(8)};
`

function ExperienceInstantConfirmationText({ textSize = 'small', lineClamp }: { textSize?: 'small' | 'medium', lineClamp?: number }) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const onTextClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    e.preventDefault()
    showModal(<ExperienceInstantConfirmationModal />)
  }

  return (
    <IconText onClick={onTextClick}>
      <LineBoltIcon colour="highlight-primary-dark" size={textSize === 'small' ? 'XS' : 'S'} />
      <BodyText lineClamp={lineClamp} colour="highlight-primary-dark" variant={textSize} weight="bold">
        {intl.formatMessage({
          id: '5LCnB-6zHVWhiXg_804n',
          defaultMessage: 'Instant confirmation',
          description: 'Badge text indicating the experience offer is instantly confirmed without provider approval',
        })}
      </BodyText>
      <LineInfoCircleIcon colour="neutral-one" size={textSize === 'small' ? 'XS' : 'S'} />
    </IconText>
  )
}

export default ExperienceInstantConfirmationText
